import React from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';
import EdgeBufferTileLayer from '#/map/components/EdgeBufferTileLayer';

function BaseMapLayers({ baseLayers, currentBaseLayer }) {
  return (
    baseLayers &&
    baseLayers
      .filter(layer => String(layer.name).toLowerCase() === currentBaseLayer)
      .map(layer =>
        L.Browser.retina && layer.hasRetinaSupport ? (
          <EdgeBufferTileLayer
            key={layer.name}
            url={layer.url}
            attribution={layer.attribution}
            maxZoom={layer.maxZoom}
            tileSize={512}
            zoomOffset={-1}
            detectRetina
            edgeBufferTiles={2}
          />
        ) : (
          <EdgeBufferTileLayer
            key={layer.name}
            url={layer.url}
            attribution={layer.attribution}
            maxZoom={layer.maxZoom}
            detectRetina
            edgeBufferTiles={2}
          />
        )
      )
  );
}

BaseMapLayers.propTypes = {
  baseLayers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currentBaseLayer: PropTypes.string.isRequired,
};

export default React.memo(BaseMapLayers);
